import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import WheelButton from '../../components/WheelButton';
import { message } from '../../../../../../../utils/stringUtils';
import Images from '../../../../../../../config/assets';

import styles from './styles';

class WheelButtons extends Component {
  state = { opacity: 1 };

  componentWillMount() {
    this.handleTransition(this.props.buttons);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ opacity: 0 }, () => this.handleTransition(nextProps.buttons));
  }

  handleTransition = () => {
    if (!this.state.opacity) this.setState({ opacity: 1 });
  };

  render() {
    const { buttons } = this.props;
    return (
      <div style={styles.container}>
        <div style={styles.title}>
          <UTLabel large bold>
            {message('Assessor:title')}
          </UTLabel>
          <UTLabel darkGray small>
            {message('Assessor:subtitle')}
          </UTLabel>
        </div>
        <div style={styles.avatarContainer}>
          <img src={Images.energyAdvisorAvatar} style={styles.wheelAvatar} alt="avatar" />
        </div>

        <div style={{ opacity: this.state.opacity, transition: 'opacity 1.5s' }}>
          {buttons.map((button, index) => (
            <WheelButton {...button} key={button.image} index={index} />
          ))}
        </div>
      </div>
    );
  }
}

WheelButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      imageHovered: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onClick: PropTypes.func
};

export default Radium(WheelButtons);
